import { BUTTON_TYPE_OPTIONS, ICON_POSITION_OPTIONS } from './constants';

export const getButtonType = (buttonType: string) => {
  const buttonTypeMap = {
    [BUTTON_TYPE_OPTIONS[0].value]: { primary: true },
    [BUTTON_TYPE_OPTIONS[1].value]: { secondary: true },
    [BUTTON_TYPE_OPTIONS[2].value]: { tertiary: true },
  };
  return buttonTypeMap[buttonType] || { primary: true };
};

export const getCustomIconPosition = (iconPosition: string) => {
  const iconPositionMap = {
    [ICON_POSITION_OPTIONS[1].value]: {
      direction: 'row',
      margin: { marginRight: '8px' },
    },
    [ICON_POSITION_OPTIONS[2].value]: {
      direction: 'column',
      margin: { marginBottom: '8px' },
    },
    [ICON_POSITION_OPTIONS[3].value]: {
      direction: 'row-reverse',
      margin: { marginLeft: '8px' },
    },
    [ICON_POSITION_OPTIONS[4].value]: {
      direction: 'column-reverse',
      margin: { marginTop: '8px' },
    },
  };
  return iconPositionMap[iconPosition] || 'row';
};
